<template>
  <div class="c-password px">
    <img class="logo" :src="images.logo_white" />
    <div class="password-text">{{ $t("loader.enterPassword") }}</div>
    <div class="password" @paste="onPasswordPaste($event)">
      <input
        class="password-input"
        type="text"
        v-for="(item, index) in numbers"
        :key="index"
        :value="numbers[index]"
        @input="onPasswordInput($event, index)"
        @keydown.delete="onPasswordDelete($event, index)"
      />
    </div>
    <div class="password-error">
      {{
        password.length === 6 && password !== systemInfo.password
          ? $t("loader.passwordMistake")
          : " "
      }}
    </div>
    <div class="buttons">
      <div
        class="button"
        :disabled="password !== systemInfo.password"
        @click="onClick"
      >
        {{ $t("loader.selectFirmware") }}
      </div>
      <div v-if="onBack" class="button" @click="onBack">
        {{ $t("back") }}
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "CPassword",
  props: {
    onBack: Function,
  },
  data() {
    return {
      numbers: ["", "", "", "", "", ""],
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      systemInfo: "systemInfo",
    }),
    password() {
      return this.numbers.join("");
    },
  },
  methods: {
    onPasswordPaste(e) {
      const clipdata = e.clipboardData || window.clipboardData;
      let value = clipdata.getData("text/plain");
      let len = value.length;
      if (len == 6) {
        this.numbers = value.split("");
        if (e.target.tagName == "INPUT") {
          const parent = e.target.parentElement;
          const inputs = parent.querySelectorAll("input");
          inputs[inputs.length - 1].focus();
        }
      } else {
        let parent = document.querySelector(".input-wrap");
        let focusInput = parent.querySelector("input.input-content:focus");
        let index = -1;
        for (let child of parent.children) {
          index += 1;
          if (child == focusInput) {
            break;
          }
        }
        if (len > 6 - index) {
          value = value.slice(0, 6 - index);
          len = value.length;
        }

        this.numbers.splice(index, len, ...value.split(""));
        const inputs = parent.querySelectorAll("input");
        inputs[index + len - 1].focus();
      }
    },
    onPasswordInput(e, index) {
      const inputValue = e.target.value;
      switch (e.inputType) {
        case "insertText":
          if (inputValue.length > 1) {
            e.target.value = inputValue.slice(-1);
          }
          if (index < this.numbers.length - 1) {
            this.numbers[index] && (this.numbers[index + 1] = e.data);
            e.target.parentNode.childNodes[index + 1].focus();
          }
          !this.numbers[index] && (this.numbers[index] = e.data);
          break;
        case "deleteContentBackward":
          this.numbers[index] = "";
          if (index !== 0) {
            e.target.parentNode.childNodes[index - 1].focus();
          }
          break;
        case "insertFromPaste":
          if (e.target.value.length > 1) {
            e.target.value = e.target.value.slice(0, 1);
          }
          break;
        case "deleteContentForward":
          this.numbers[index] = "";
          break;
      }
      this.numbers = [...this.numbers];
    },
    onPasswordDelete(e, index) {
      if (e.key == "Backspace") {
        this.numbers[index] = "";
        if (index != 0) {
          setTimeout(() => {
            e.target.parentNode.childNodes[index - 1].focus();
          }, 0);
        }
      }
    },
    onClick() {
      if (this.password !== this.systemInfo.password) return;
      this.$emit("select");
    },
  },
};
</script>
<style lang="scss" scoped>
.c-password {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;

  .logo {
    width: 300px;
    height: auto;
    margin-bottom: 60px;
  }

  .buttons {
    @include flex-center;

    .button {
      @include linear-button;
      width: 480px;
      height: 80px;
      line-height: 80px;
      margin-bottom: 60px;

      & + .button {
        width: 180px;
        margin-left: 50px;
      }
    }
  }

  .password-text {
    font-size: 36px;
    margin-bottom: 20px;
  }

  .password-input {
    width: 100px;
    height: 80px;
    border: none;
    outline: none;
    text-align: center;
    border-bottom: 2px solid #ebebeb;
    margin-right: 20px;
    font-weight: 500;
    font-size: 48px;
    caret-color: $primary-color;

    &:focus {
      border-color: $primary-color;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  .password-error {
    height: 50px;
    font-size: 32px;
    color: #e43e3b;
    margin-top: 20px;
    margin-bottom: 180px;
  }
}
</style>
